import React from 'react'
import flatMap from 'lodash/flatMap'

import { RiskProducts } from '@containers/RiskProducts'
import { ParticipantFilter } from './ParticipantFilter'

export const JointRiskProducts = ({ participantsQueries, config }) => {
  const [selectedParticipantId, setSelectedParticipantId] = React.useState('both')
  const selectedParticipantQuery = participantsQueries.find((participantQuery) => participantQuery.participant.id === selectedParticipantId)

  const riskProducts = selectedParticipantQuery
    ? selectedParticipantQuery.riskProducts.data
    : flatMap(participantsQueries, (participantQuery) => participantQuery.riskProducts.data)

  return (
    <>
      <RiskProducts
        filter={(view) => (
          <ParticipantFilter
            showBoth
            filteredItemsName={'risk products'}
            view={view}
            participantsQueries={participantsQueries}
            selectedParticipantId={selectedParticipantId}
            setSelectedParticipantId={setSelectedParticipantId}
          />
        )}
        scenario={{
          id: selectedParticipantQuery?.scenario.data.baseScenario.id,
        }}
        riskProducts={riskProducts}
        crudActions={selectedParticipantQuery?.riskProducts.actions}
        tenant={config.tenant}

        supportedRiskProductTypes={config.supportedRiskProductTypes}
        serviceProviders={config.serviceProviders}
        featureToggles={config.featureToggles}
      />
    </>
  )
}
